// src/boot/router-access.js
let routerInstance = null;

export default ({ router }) => {
  routerInstance = router;
};

export { routerInstance };
